module.exports = __webpack_public_path__ + "img/20210830_145310.95c18d8e.jpg";